// extracted by mini-css-extract-plugin
module.exports = {"first":"HeaderTitle_first__18Tl9","second":"HeaderTitle_second__3HVLK","third":"HeaderTitle_third__1d2By","four":"HeaderTitle_four__2VkK-"};